import React from "react";

function SMAlerts({ data, loading, error, onRepAlertClick, onStaleClick }) {
  const repAlerts = Array.isArray(data?.repAlerts) ? data.repAlerts : [];
  const staleCount = Number(data?.staleLeadsCount || 0);

  const hasAlerts = repAlerts.length > 0 || staleCount > 0;

  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-bell" />
        <span>Alerts</span>
        <span className="dashboard-card-v2-count">
          {repAlerts.length + (staleCount > 0 ? 1 : 0)}
        </span>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-list">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="dashboard-skeleton-row" />
            ))}
          </div>
        ) : !hasAlerts ? (
          <div className="dashboard-empty">
            <i className="fas fa-check-circle" />
            <p>All quiet — no active alerts.</p>
          </div>
        ) : (
          <div className="sm-alerts-list">
            {repAlerts.map((r) => (
              <button
                type="button"
                key={r.user_id}
                className="sm-alert-row sm-alert-warning sm-alert-row-clickable"
                onClick={() => onRepAlertClick && onRepAlertClick(r)}
              >
                <i className="fas fa-exclamation-triangle" />
                <span>
                  <strong>{r.full_name}</strong> has {r.overdue_count} overdue Next Contacts
                </span>
                <i className="fas fa-arrow-right sm-alert-row-arrow" />
              </button>
            ))}
            {staleCount > 0 && (
              <button
                type="button"
                className="sm-alert-row sm-alert-info sm-alert-row-clickable"
                onClick={() => onStaleClick && onStaleClick()}
              >
                <i className="fas fa-clock" />
                <span>
                  <strong>{staleCount}</strong> lead{staleCount === 1 ? "" : "s"} with no
                  activity in 60+ days
                </span>
                <i className="fas fa-arrow-right sm-alert-row-arrow" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SMAlerts;